import { Action } from "@iva/store-utils";
import { Optional } from "#types";

/**
 * state is in analogy to google guava Service https://github.com/google/guava/wiki/ServiceExplained#using-a-service
 */
export type EnvironmentState = {
    SERVICE_URL: string;
    state:
        | "new"
        | "starting"
        | "running"
        | "stopping"
        | "terminated"
        | "failed";
    refetchTimeout: number;
};

/** actions */
export enum EnvironmentActionTypes {
    UPDATE_ENVIRONMENT = "@@environment/UPDATE_ENVIRONMENT",
    LOAD_START = "@@environment/LOAD_START",
    LOAD_ERROR = "@@environment/LOAD_ERROR",
    LOAD_SUCCESS = "@@environment/LOAD_SUCCESS",
}

export type LoadEnvironmentStartAction =
    Action<EnvironmentActionTypes.LOAD_START>;
export type LoadEnvironmentErrorAction = Action<
    EnvironmentActionTypes.LOAD_ERROR,
    Optional<unknown>
>;
export type LoadEnvironmentSuccessAction =
    Action<EnvironmentActionTypes.LOAD_SUCCESS>;
export type UpdateEnvironmentAction = Action<
    EnvironmentActionTypes.UPDATE_ENVIRONMENT,
    Partial<EnvironmentState>
>;
export type EnvironmentActions =
    | LoadEnvironmentStartAction
    | LoadEnvironmentErrorAction
    | LoadEnvironmentSuccessAction
    | UpdateEnvironmentAction;
